import { render, staticRenderFns } from "./site-internet-marseille.vue?vue&type=template&id=6b1794d4&scoped=true&"
import script from "./site-internet-marseille.vue?vue&type=script&lang=js&"
export * from "./site-internet-marseille.vue?vue&type=script&lang=js&"
import style0 from "./site-internet-marseille.vue?vue&type=style&index=0&id=6b1794d4&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1794d4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Scroll: require('/app/components/Scroll.vue').default,TakeStock: require('/app/components/TakeStock.vue').default,FooterV2: require('/app/components/FooterV2.vue').default})
